import { FC, PropsWithChildren } from 'react'

import styled from 'styled-components'

import { Sidebar } from 'src/Components/Sidebar'
import { colors, device } from 'src/Helpers/constants.ts'
import { UserInfo } from 'src/Components/UserInfo'
import { useGetProfileQuery } from 'src/Redux/api/authApi'
import { MobSidebar } from 'src/Components/Sidebar/MobSidebar.tsx'
import { useResponsive } from 'src/Helpers/useResponsive.tsx'

const Container = styled.div`
  display: grid;
  grid-template-areas:
    'sidebar content'
    'sidebar content';
  grid-template-columns: auto 1fr;
  grid-template-rows: auto 1fr;
  height: 100%;
  padding: 20px;
`

const SidebarWrapper = styled.div`
  grid-area: sidebar;
  z-index: 4;
`

const SidebarContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 20px;
`

const Content = styled.div`
  grid-area: content;
  height: calc(100vh - 40px);
  overflow: hidden;
  padding: 30px 20px 20px 37px;
  margin: 0 auto;
  width: 100%;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;

  @media ${device.tabletMax} {
    padding: 40px 0px 0px 0px;
  }
`

const Separator = styled.div`
  position: absolute;
  top: 82px;
  left: 20px;
  height: 1px;
  width: 70%;
  margin: 20px 0;
  background: linear-gradient(
    to right,
    ${colors.secondGray} 0%,
    transparent 100%
  );
`

export type PageLayoutProps = PropsWithChildren

export const PageLayout: FC<PageLayoutProps> = ({ children }) => {
  const { data: user } = useGetProfileQuery()

  const { isTablet } = useResponsive()

  const sidebar = isTablet ? (
    <MobSidebar userName={`${user?.lastName} ${user?.firstName}`} />
  ) : (
    <SidebarWrapper>
      <SidebarContainer>
        <Sidebar />
        <UserInfo name={`${user?.lastName} ${user?.firstName}`} />
      </SidebarContainer>
      <Separator />
    </SidebarWrapper>
  )

  return (
    <Container>
      {sidebar}
      <Content>{children}</Content>
    </Container>
  )
}
